import { isDeepStrictEqual } from 'node:util';
import { fields, variant } from 'variant';
import type { LooseAppManifest } from '@wix/cli-app-manifest';

export const ManifestUpdateResult = variant({
  Changed: fields<{ updatedComponents: LooseAppManifest['components'] }>(),
  Unchanged: {},
});

export function checkManifestForChanges(
  previous: LooseAppManifest | null,
  latest: LooseAppManifest
) {
  if (previous == null) {
    return ManifestUpdateResult.Changed({ updatedComponents: [] });
  }

  if (isDeepStrictEqual(previous, latest)) {
    return ManifestUpdateResult.Unchanged();
  }

  const oldComponentsMap = new Map(
    previous.components.map((comp) => [comp.compId, comp])
  );

  const changedComponents = latest.components.filter((newComp) => {
    const oldComp = oldComponentsMap.get(newComp.compId);
    return !isDeepStrictEqual(newComp, oldComp);
  });

  return ManifestUpdateResult.Changed({ updatedComponents: changedComponents });
}
